import { p as promiseResolve, b as bootstrapLazy } from './index-1c5c47b4.js';
export { s as setNonce } from './index-1c5c47b4.js';

/*
 Stencil Client Patch Esm v3.4.0 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
  return promiseResolve();
};
const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
    return bootstrapLazy([["pwa-camera-modal", [[1, "pwa-camera-modal", {
      "facingMode": [1, "facing-mode"],
      "hidePicker": [4, "hide-picker"],
      "present": [64],
      "dismiss": [64]
    }]]], ["pwa-action-sheet", [[1, "pwa-action-sheet", {
      "header": [1],
      "cancelable": [4],
      "options": [16],
      "open": [32]
    }]]], ["pwa-toast", [[1, "pwa-toast", {
      "message": [1],
      "duration": [2],
      "closing": [32]
    }]]], ["pwa-camera", [[1, "pwa-camera", {
      "facingMode": [1, "facing-mode"],
      "handlePhoto": [16],
      "hidePicker": [4, "hide-picker"],
      "handleNoDeviceError": [16],
      "noDevicesText": [1, "no-devices-text"],
      "noDevicesButtonText": [1, "no-devices-button-text"],
      "photo": [32],
      "photoSrc": [32],
      "showShutterOverlay": [32],
      "flashIndex": [32],
      "hasCamera": [32],
      "rotation": [32],
      "deviceError": [32]
    }]]], ["pwa-camera-modal-instance", [[1, "pwa-camera-modal-instance", {
      "facingMode": [1, "facing-mode"],
      "hidePicker": [4, "hide-picker"],
      "noDevicesText": [1, "no-devices-text"],
      "noDevicesButtonText": [1, "no-devices-button-text"]
    }, [[16, "keyup", "handleBackdropKeyUp"]]]]]], options);
  });
};
export { defineCustomElements };